import React, { useState, useEffect } from "react";
import "../CSS/LaporkanKendalaTenagaKesehatan.css";

function LaporkanKendalaTenagaKesehatan() {
  const user = JSON.parse(localStorage.getItem("user"));

  const [formData, setFormData] = useState({
    issueType: "",
    description: "",
    file: null,
  });

  const [reports, setReports] = useState([]);

  // Ambil riwayat laporan sesuai role tenaga kesehatan
  useEffect(() => {
    const fetchReports = async () => {
      if (!user) return;
      try {
       const endpoint = `https://api-tibismart.tifpsdku.com/api/laporan/user/${user.id_user}`;
        const res = await fetch(endpoint);
        if (!res.ok) throw new Error("Gagal mengambil riwayat laporan");
        const data = await res.json();
        setReports(data);
      } catch (err) {
        console.error(err);
      }
    };
    fetchReports();
  }, [user]);

  const handleChange = (e) => {
    const { name, value, type, files } = e.target;
    setFormData({
      ...formData,
      [name]: type === "file" ? files[0] : value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formData.issueType) {
      alert("Harap isi Jenis Kendala");
      return;
    }

    try {
      const payload = new FormData();
      payload.append("id_tenagakesehatan", user.id_tenagakesehatan); // HARUS SAMA DENGAN BACKEND
      payload.append("jenis_kendala", formData.issueType);
      payload.append("deskripsi_kendala", formData.description);
      if (formData.file) payload.append("screenshot_file", formData.file);

      const res = await fetch("https://api-tibismart.tifpsdku.com/api/laporan/kirim", {
        method: "POST",
        body: payload, 
      });

      if (!res.ok) throw new Error("Gagal mengirim laporan");

      const data = await res.json();

      alert("Laporan berhasil dikirim!");
      setFormData({ issueType: "", description: "", file: null });

      // Tambahkan laporan baru ke state
      setReports((prev) => [...prev, data.laporan]);
    } catch (err) {
      console.error(err);
      alert("Terjadi kesalahan saat mengirim laporan");
    }
  };

  return (
    <div className="laporkan-page">
      <div className="content">
        <div className="main-content">
          <div className="left-column">
            <p className="subtitle" style={{ marginLeft: "200px", marginTop: "40px" }}>
              Jika kamu mengalami kendala teknis, silakan isi form di bawah ini. Tim kami akan segera membantu.
            </p>

            <div className="report-section">
              <form onSubmit={handleSubmit} className="report-form">
                <div className="form-group">
                  <label>Jenis Kendala</label>
                  <input
                    type="text"
                    name="issueType"
                    value={formData.issueType}
                    onChange={handleChange}
                    required
                  />
                </div>

                <div className="form-group">
                  <label>Deskripsi Kendala</label>
                  <textarea
                    name="description"
                    rows="4"
                    value={formData.description}
                    onChange={handleChange}
                  />
                </div>

                <div className="form-group">
                  <label>Upload Screenshot (Opsional)</label>
                  <input type="file" name="file" onChange={handleChange} />
                </div>

                <button type="submit" className="submit-btn">Kirim</button>
              </form>
            </div>
          </div>

          <div className="table-section">
            <h2>Riwayat Laporan Kendala</h2>
            <table>
              <thead>
                <tr>
                  <th>ID</th>
                  <th>Jenis Kendala</th>
                  <th>Tanggal Lapor</th>
                  <th>Status</th>
                  <th>Tindak Lanjut</th>
                </tr>
              </thead>
              <tbody>
                {reports.length === 0 ? (
                  <tr>
                    <td colSpan="5" className="empty-text">Belum ada laporan</td>
                  </tr>
                ) : (
                  reports.map((r) => (
                    <tr key={r.id_laporan}>
                      <td>{r.id_laporan}</td>
                      <td>{r.jenis_kendala}</td>
                      <td>{r.tanggal_lapor ? new Date(r.tanggal_lapor).toLocaleDateString("id-ID") : "-"}</td>
                      <td>{r.status}</td>
                      <td>{r.tindak_lanjut || "-"}</td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
}

export default LaporkanKendalaTenagaKesehatan;
